import { useCallback, useEffect, useState } from "react";
import { useCustomerAuth } from "./auth";
import { getProfile, saveProfile, type CustomerProfile } from "./profile";

/**
 * Laadt + bewaart het klantprofiel (/customers/{uid}). `error` is true als Firestore
 * niet bereikbaar is — dat is op localhost normaal (App Check); werkt op de live site.
 */
export function useProfile() {
  const { user } = useCustomerAuth();
  const uid = user?.uid;
  const [profile, setProfile] = useState<CustomerProfile | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  const reload = useCallback(async () => {
    if (!uid) return;
    setLoading(true);
    try {
      setProfile(await getProfile(uid));
      setError(false);
    } catch {
      setError(true);
    } finally {
      setLoading(false);
    }
  }, [uid]);

  useEffect(() => { void reload(); }, [reload]);

  const save = useCallback(async (patch: Partial<CustomerProfile>) => {
    if (!uid) return;
    await saveProfile(uid, patch);
    setProfile((p) => (p ? { ...p, ...patch } : p));
  }, [uid]);

  return { uid, profile, loading, error, reload, save };
}
